import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { UserProvider } from './contexts/user.context';
import { BrowserRouter } from 'react-router-dom';
import { AlertsProvider } from './contexts/Alerts.context';
import PopupAlert from './components/Alerts/PopupAlert.component';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AlertsProvider>
      <UserProvider>
        <BrowserRouter>
          <PopupAlert />
          <App />
        </BrowserRouter>
      </UserProvider>
    </AlertsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
